// src/components/NavigationSteps.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  CarOutlined,
  CheckCircleOutlined,
  DesktopOutlined,
  EnvironmentOutlined,
  CompassOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Card, Typography } from "antd";

const { Text } = Typography;

/**
 * @param {string} selectedKey - la clé (ou chemin) de l'étape sélectionnée
 */
export const NavigationStepsCap = ({ selectedKey }) => {
  // Liste ordonnée des étapes
  const steps = [
    {
      key: "tetra_bus",
      title: "TETRA BUS",
      path: "/cap/tetra_bus",
      icon: <CarOutlined />,
    },
    {
      key: "po_siel",
      title: "SAE-TR",
      //label: "Validation PO Siel",
      path: "/cap/po_siel",
      icon: <CheckCircleOutlined />, 
    },
    {
      key: "geolocalisation",
      title: "AD premiers sortants par ligne",
      // label: "Géolocalisation de l'AD",
      path: "/cap/geolocalisation",
      icon: <EnvironmentOutlined />,
    },
    {
      key: "coquille_config_dsp",
      title: "Tests radio",
      // label: "Coquille Config Dsp",
      path: "/cap/coquille_config_dsp",
      icon: <CompassOutlined />,
    },
    {
      key: "reporting_tetra_sae",
      title: "Reporting bascule TETRA / SAE",
      path: "/cap/reporting_tetra_sae",
      icon: <DesktopOutlined />,
    },
    {
      key: "incidents_habilitations",
      title: "Incidents habilitations / accès CDS",
      // label: "Habilitations / Accès",
      path: "/cap/declarations_pb_cap",
      icon: <ExclamationCircleOutlined />,
    },
  ];

  return (
    <div style={{ 
      position: "sticky",
      top: "68px",
      zIndex: 1000,
      backgroundColor: "#fff",
      paddingTop: "15px",
      paddingBottom: "15px",
      marginBottom: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.06)"
    }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: "center",
        }}
      >
      {steps.map((step) => {
        const active = selectedKey === step.key;

        return (
          <Link key={step.key} to={step.path} style={{ textDecoration: "none" }}>
            <Card
              hoverable
              size="small"
              style={{
                width: 180,
                height: 90,
                borderRadius: 10,
                boxShadow: active
                  ? "0 0 8px rgba(24, 144, 255, 0.6)"
                  : "0 1px 5px rgba(0,0,0,0.1)",
                borderColor: active ? "#1677ff" : "#f0f0f0",
                transition: "all 0.2s ease",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ fontSize: 22, color: active ? "#1677ff" : "#999" }}>
                {step.icon}
              </div>
              <Text strong style={{ fontSize: 13 }}>
                {step.title}
              </Text>
              <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>
                {step.label}
              </div>
            </Card>
          </Link>
        );
      })}
      </div>
    </div>
  );
};
